import React from 'react';
import { PaginationContext } from './CheckEmail';
import { ConfirmModal } from '../../../utils/ConfirmModal';
import {
  USER_ALREADY_MEMBER_CONFIRMATION_MESSAGE,
  USER_EXIST_IN_PLATFORM_CONFIRMATION_MESSAGE,
} from '../../../utils/constants';

export type Props = {
  canShowModal: (val: boolean) => void;
  showModal?: boolean;
  isOrgMember?: boolean;
  paginationContext?: PaginationContext;
  userId: string | undefined;
};

const ConfirmationModal = ({
  canShowModal,
  showModal = false,
  paginationContext,
  userId,
  isOrgMember,
}: Props) => {
  const message = isOrgMember
    ? USER_ALREADY_MEMBER_CONFIRMATION_MESSAGE
    : USER_EXIST_IN_PLATFORM_CONFIRMATION_MESSAGE;
  const navigationPath = isOrgMember
    ? `/organisations/${paginationContext!.orgCode}/members/${userId}/edit`
    : `/members/${userId}/edit`;
  const pageNumber = isOrgMember
    ? paginationContext!.pageNumber
    : paginationContext!.pageNumber + 1;

  return (
    <ConfirmModal
      modalVisibility={canShowModal}
      open={showModal}
      heading={'Edit?'}
      message={message}
      navigation={{
        path: navigationPath,
        context: { pageNumber },
      }}
      redirectUrlOnYes={`/organisations/${userId}/edit`}
    />
  );
};

export default ConfirmationModal;
